// extracted by mini-css-extract-plugin
module.exports = {"tab":"FqgXif","icon":"L6CDKG","active":"Rc0OsJ","featured":"PUXp0B"};